import _ from 'lodash';


import submenuCeroKm from '../menus/submenu-cerokm';
import CRUDPage from '../CRUDPage';
import NiceDate from '../../components/common/NiceDate';
import MongoDocEditor from '../../components/lego/MongoDocEditor';
import MultilineTextEditor from '../../components/common/editors/MultilineTextEditor';
import HighlightedText from '../../components/common/HighlightedText';
import LegoContextSummary from '../../components/lego/LegoContextSummary';
import SpecSourceBadge from './components/SpecSourceBadge';
import RemapSpecGroupsTable from './components/RemapSpecGroupsTable';
import { UserAvatarLive } from '../../components/common/UserAvatarLive';
import { fromNow } from '../../components/common/TimeUtils';
import BadgeId from '../../components/common/BadgeId';
import UserAvatar from '../../../../components/common/UserAvatar';
import { LegoFiltersBar } from '../../components/common/LegoFiltersBar';
import ModelContextEditor from '../../components/lego/ModelContextEditor';
import NotesEditor from '../../components/common/editors/NotesEditor';
import { IconButton } from '../../components/common/IconButton';

export default class CeroKmSpecsGroupsManager extends CRUDPage {
  constructor(props) {
    super(props, '/services/cerokm/specsgroup');

    this.submenu = submenuCeroKm;
    // this.state.columnSort = { index: 1, asc: true, sorter:  };



    this.newObjectTemplate = {
      key: '',
      text: '',
      createdBy: this.getLoggedUserSignature(),
    };

    this.filterAndSortObjects()

    // this.canDelete = true;
  }

  remap(selected) {
    if (!selected.length) {
      return;
    }

    let ids = selected.map(o => o._id);

    const table = <RemapSpecGroupsTable
      specGroupIds={ids}
      objects={this.state.objects}
      onRemapped={(stats) => {
        this.closeModal();
        this.alert(`Groups remapped successfully: ${JSON.stringify(stats)}`);
        this.fetchObjects();
      }}
    />

    this.openModal(table, { title: `Remap ${selected.length} specs groups` });
  }

  getColumnsDefinition(objects) {
    // Keep the subtrims always grouped with their trim
    let sortByBasedOn = f => {
      let byId = _.keyBy(objects, '_id');

      return [
        o => o.basedOn && byId[o.basedOn] ? f(byId[o.basedOn]) : f(o),
        o => o.basedOn || o._id,
        o => o.basedOn ? 1 : 0,
        o => f(o)
      ];
    }

    return [
      { content: 'Id', className: 'text-center', sorter: sortByBasedOn(o => new Date(o.createdAt)) },
      { content: 'Context', className: 'text-center', sorter: sortByBasedOn(o => o.context.modelId) },
      { content: 'Type', className: 'text-center' },
      { content: 'Name', className: 'text-center', sorter: sortByBasedOn(o => o.name) },
      { content: 'Source', className: 'text-left', sorter: sortByBasedOn(o => o.sourceId) },
      { content: 'Disabled', className: 'text-center', sorter: sortByBasedOn(o => o.disabled) },
    ];
  }

  getObjectColumns(modelObject, def, i, allRows) {
    let { _id, createdAt, updatedAt, createdBy, updatedBy, context, type, name, basedOn, code, sourceId } = modelObject;
    updatedAt = updatedAt || createdAt;
    updatedBy = createdBy || updatedBy;

    let indent = type === 'subtrim';
    let rowTypeBg = type === 'subtrim' ? 'bg-light pl-4' : '';
    return [
      <td className={'no-wrap'}>
        {updatedBy ? ((updatedBy?.userId) ? <UserAvatar user={updatedBy} /> :
          <UserAvatarLive id={updatedBy?.id || updatedBy} />) : null}
        <span className={'d-inline-block ml-2 align-middle'}>
          <span className={'text-info small mr-2'}>{updatedAt ? fromNow(updatedAt) : ''}</span>
          <BadgeId id={_id} />
        </span>
      </td>,
      <td key={'context'} className={rowTypeBg}>
        <LegoContextSummary context={modelObject.context} />
      </td>,
      <td key={'type'} className={rowTypeBg}>
        <span className={`badge badge-${type === 'subtrim' ? 'secondary' : 'dark'}`}>{type}</span>
      </td>,
      <td key={'name'} className={rowTypeBg + (indent ? ' ' : ' font-weight-bold')}>
        {name}
      </td>,
      <td key={'sourceId'}>
        <SpecSourceBadge small sourceId={sourceId} />
      </td>,
      <td key={'disabled'}>
        { modelObject.disabled ? <IconButton level={'danger'} icon={'not_interested'}/> : null}
      </td>
    ];
  }

  getSelectionButtons(selection) {
    if (selection?.length && _.every(selection, o => o.type === 'subtrim')) {
      return <>
        {super.getSelectionButtons(selection)}
        <span>
          <button className='btn btn-xs btn-primary' onClick={() => this.remap(selection)}>Remap</button>
        </span>
      </>;
    }
    return super.getSelectionButtons(selection);
  }

  getFacetFiltersComponent() {
    return <LegoFiltersBar onChange={this.onFiltersChange.bind(this)} filter={this.state.facetFilters} fields={['context']} />
  }

  getObjectEditorComponent(obj, defaultOnSaveCbk, defaultOnCancelCbk) {
    const extendSchema = {
      context: (value, onChange) => <ModelContextEditor value={_.isArray(value) ? value[0] : value} onChange={onChange} />,
      disabled: (value, onChange) => <span className={`btn btn-${value ? 'primary' : 'secondary'} btn-xs`}
                                    onClick={() => onChange(!value)}>{(value ?? false).toString()}</span>,
      notes: (value, onChange) => <NotesEditor value={value} onChange={onChange}/>
    }

    return <MongoDocEditor obj={obj} showFields={_.keys({ ...obj, disabled: 'justSoTheKeyExists' })} onSave={defaultOnSaveCbk} extendSchema={extendSchema}
      onCancel={defaultOnCancelCbk} />;
  }
}
